module.exports = __webpack_public_path__ + "assets/c95dafa77a3cc0314b65312bef8b092d.png";